import 'swiper/css'
import * as React from 'react'
import { Autoplay, Swiper as SwiperInstance, SwiperOptions } from 'swiper'
import { Button } from '../../components/UI/Button'
import { Card } from '../../components/UI'
import { Container } from '../../components/UI/Container'
import { ModuleWrapper, Slide, SliderInner, SliderNavigation, SliderWrapper } from './styled'
import { SbTestimonialSliderItem, TestimonialSliderProps } from './types'
import { Swiper, SwiperSlide } from 'swiper/react'
import { TestimonialSliderItem } from './Item'
import { TitleWithPrefix } from '../../components/UI/TitleWithPrefix'
import { sbEditable } from '@storyblok/storyblok-editable'
import { useTestimonials } from '../../lib/hooks/useTestimonials'

const swiperOptions: SwiperOptions = {
  modules: [Autoplay],
  spaceBetween: 0,
  loop: true,
  slidesPerView: 'auto',
  loopedSlides: 8,
  loopedSlidesLimit: false,
  speed: 600,
  autoplay: {
    delay: 4000,
  },
}

export const TestimonialSlider = ({ blok }: TestimonialSliderProps) => {
  const testimonialsToShow: SbTestimonialSliderItem[] = useTestimonials(blok.testimonials)
  const [swiper, setSwiper] = React.useState<SwiperInstance | null>(null)

  return (
    <ModuleWrapper {...sbEditable(blok)}>
      {blok.headline && (
        <Container>
          <TitleWithPrefix title={blok.headline} headlineSize={blok.headlineSize} headlineType={blok.headlineSyntax} />
        </Container>
      )}
      <SliderWrapper>
        <Container>
          <SliderInner>
            <Swiper onSwiper={swiper => setSwiper(swiper)} {...swiperOptions}>
              {testimonialsToShow.map((testimonial, index) => (
                <SwiperSlide key={`${testimonial.uuid}`}>
                  <Slide>
                    <Card cardIcon="quotes" style={{ padding: '1em' }}>
                      <TestimonialSliderItem
                        name={testimonial.content.name}
                        image={testimonial.content.logo}
                        position={testimonial.content.position}
                        quote={testimonial.content.content}
                      />
                    </Card>
                  </Slide>
                </SwiperSlide>
              ))}
            </Swiper>
          </SliderInner>
        </Container>
      </SliderWrapper>
      <Container>
        <SliderNavigation>
          <Button
            $size="small"
            $variant="tertiary"
            onClick={() => swiper && swiper.slidePrev()}
            iconLeft="arrow-left"
            $ignoreTheme
          />
          <Button
            $size="small"
            $variant="tertiary"
            onClick={() => swiper && swiper.slideNext()}
            iconLeft="arrow-right"
            $ignoreTheme
          />
        </SliderNavigation>
      </Container>
    </ModuleWrapper>
  )
}
